import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import { getArticle } from "actions/article/article.functions";
import { Loader, SEO } from "components";
import images from "assets/images";

import { blogRoute } from "constants/routes";

import { WEBSITE_URI } from 'constants/variables';
import { FacebookShareButton, TwitterShareButton, LinkedinShareButton, EmailShareButton, FacebookIcon, TwitterIcon, LinkedinIcon, EmailIcon } from "react-share";

class BlogArticleDetails extends PureComponent {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getArticle(window.location.pathname));
  }

  render() {
    const { singleArticle, singleArticleIsFetching } = this.props;

    if (singleArticleIsFetching)
      return (
        <div className="loader__container">
          <Loader />
        </div>
      );
    if (!singleArticle && !singleArticleIsFetching)
      return (
        <main className="view-blog">
          <div className="wrapper">
            <div className="view-blog__single view-blog__single--error u-type--center">
              <div className="view-blog__single__heading">
                <h1 className="view-blog__single__title u-type--beta u-type--primary">
                  Oops...
                </h1>
              </div>
              <div className="view-blog__single__content">
                <p className="u-type--epsilon">
                  This article doesn't seem to exist.
                </p>
                <Link
                  className="btn btn--secondary btn--med u-spc-top--xlrg"
                  to={blogRoute}
                >
                  Back to article list
                </Link>
              </div>
            </div>
          </div>
        </main>
      );

    const seoProps = {
      SEOTitle: singleArticle.title.rendered,
      SEODescription: singleArticle.content.rendered.slice(0, 60),
      SEOUrl: window.location.href
    };

    const shareUrl = `${WEBSITE_URI}blog/${singleArticle.slug}`;

    return (
      <main className="view-article">
        {<SEO {...seoProps} />}
        <div className="wrapper">
          <article className="view-blog__single">
            <div className="view-blog__single__heading">
              <h1 className="view-blog__single__title u-type--beta u-type--primary">
                {singleArticle.title.rendered}
              </h1>
              <div className="article__meta">
                <span className="article__meta__date">
                  {moment(singleArticle.publishDate).format("MMMM DD, YYYY.")}
                </span>
              </div>
            </div>
            {singleArticle.better_featured_image ? (
              <div
                className="view-blog__single__visual"
                style={{
                  backgroundImage: `url(${
                    singleArticle.better_featured_image.source_url
                  })`
                }}
              />
            ) : (
              <div
                className="view-blog__single__visual"
                style={{
                  backgroundImage: `url(${images.blogVisualDefault})`
                }}
              />
            )}
            <div className="view-blog__single__content">
              <div
                dangerouslySetInnerHTML={{
                  __html: singleArticle.content.rendered
                }}
              />
              <div className="social__container">
                <div className="social__header">
                  <h1 className="u-type--eta u-type--o50">Share this article</h1>
                </div>
              <div className="social">
                <FacebookShareButton url={shareUrl} className="social__share-button"><FacebookIcon size={32} round={true} /></FacebookShareButton>
                <TwitterShareButton url={shareUrl} className="social__share-button"><TwitterIcon size={32} round={true} /></TwitterShareButton>
                <LinkedinShareButton url={shareUrl} className="social__share-button" title={singleArticle.title.rendered} description={singleArticle.excerpt.rendered}><LinkedinIcon size={32} round={true} /></LinkedinShareButton>
                <EmailShareButton url={shareUrl} className="social__share-button"><EmailIcon size={32} round={true} /></EmailShareButton>
              </div>
              </div>
              <Link
                className="btn btn--secondary btn--med u-spc-top--xlrg"
                to={blogRoute}
              >
                Back to blog
              </Link>
            </div>
          </article>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => {
  const { singleArticle, singleArticleIsFetching } = state.articles;

  return { singleArticle, singleArticleIsFetching };
};

export default connect(mapStateToProps)(BlogArticleDetails);



// WEBPACK FOOTER //
// ./src/views/BlogArticleDetails.jsx